import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TwillioAuthData } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: TwillioAuthData) =>
    $actions.user.signInTwillio(dispatch, values),
  );
};
